// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"8a01c1a6","407":"f6fa3f36"}[chunkId] + ".chunk.js";
};